import { render, staticRenderFns } from "./NewEnrollment.vue?vue&type=template&id=aaa50d78&"
import script from "./NewEnrollment.vue?vue&type=script&lang=js&"
export * from "./NewEnrollment.vue?vue&type=script&lang=js&"
import style0 from "./NewEnrollment.vue?vue&type=style&index=0&id=aaa50d78&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports